import React, { useEffect, useRef, useState } from "react";
import "./Contact.scss";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import contactpage from "../../Assets/Images/contact-page.jpg"

import fb from "../../Firebase/firebase";
import emailjs from '@emailjs/browser';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const DB = fb.firestore()
const CF = DB.collection('Contact_Form');

const ContactPage = () => {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

  }, []);

  const form = useRef();
  const [userData, setUserData] = useState({
    FirstName: "",
    Email: "",
    Mobile: "",
    Message: "",
    LastName: ""
  });

  let name, value;
  const postUserData = (e) => {
    name = e.target.name;
    value = e.target.value;
    setUserData({ ...userData, [name]: value });
  }

  //connect with firebase
  const SubmitData = async (e) => {
    e.preventDefault();
    const { FirstName, LastName, Email, Mobile, Message } = userData;
    if (FirstName && LastName && Email && Mobile && Message) {


      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      if (!emailRegex.test(userData.Email)) {
        toast.warning('Please enter a valid email address');
        return
      }

      if (typeof Mobile !== "undefined") {

        var pattern = new RegExp(/^[0-9\b]+$/);

        if (!pattern.test(userData.Mobile)) {
          toast.warning("Please enter only number.");
          return

        } else if (userData.Mobile.length !== 10) {
          toast.warning("Please enter 10 digit Mobile number.");
          return
        }
      }

      try {

        CF.add({
          FirstName: FirstName,
          LastName: LastName,
          Email: Email,
          Mobile: Mobile,
          Message: Message
        }).then((docRef) => {
          toast.success('Message Sent Successfully');
        }).catch((error) => {
          console.error("error:", error);
        });

        emailjs.sendForm('service_blv6m39', 'template_jj202jo', form.current, 'kNeMTvdXn2pKHy2m6')
          .then((result) => {
            console.log(result.text);

          }, (error) => {
            console.log(error.text);
          });

        setUserData({
          FirstName: "",
          LastName: "",
          Email: "",
          Mobile: "",
          Message: ""
        })

        // console.log("Document written with ID: ", docRef.id);
      } catch (e) {
        console.error("Error adding document: ", e);
        toast.warning("Error adding document")
      }
    }
    else {
      toast.warning('Please fill the data', {
      });
    }
  };

  return (
    <div className="contact-page">
      <ToastContainer
        className="toast-container-right-center"
        toastClassName="custom-toast"
        bodyClassName="custom-body"
        hideProgressBar={true}

      />
      <div className="section-title">
        <h3>Contact Us</h3>
      </div>
      <section className="contact-container">

        {/* Contact Form */}
        <div className="contact-form">
          <h3>Get in Touch</h3>
          <form action="POST" ref={form}>
            <input type="text" placeholder='First Name' name='FirstName'
              value={userData.Name}
              onChange={postUserData}
              required />
            <input type="text" id="" placeholder='Last Name' name='LastName'
              value={userData.LastName}
              onChange={postUserData}
              required />
            <input type="email" id="" placeholder='Email' name='Email'
              value={userData.Email}
              onChange={postUserData}
              required />
            <input type="text" id="" placeholder='Mobile' name='Mobile'
              value={userData.Mobile}
              onChange={postUserData}
              required />
            <textarea id="" placeholder='Message' name="Message" rows="5"
              value={userData.Message}
              onChange={postUserData}
              required></textarea>
            <button onClick={SubmitData} type="submit">Send Message</button>
          </form>
        </div>

        {/* Contact Information */}
        <div className="contact-info">
          {/* <h3>Contact Information</h3> */}
          <img src={contactpage} alt="contact" />
          <div className="contact-info-item">
            <a href="tel:919825966404"><p><FaPhoneAlt />  +91-9825966404</p></a>
            <a href="mailto:gsslifesciences@gmail.com"><p><FaEnvelope />gsslifesciences@gmail.com</p></a>
            <a target="_blank" href="https://www.google.com/maps/place/Vadvali+Mehta+Pole/@23.037389,72.579648,16z/data=!4m6!3m5!1s0x395e8534399d8e91:0x74e710d0ac8e1878!8m2!3d23.037389!4d72.579648!16s%2Fg%2F11pwvgh_8p?hl=en&entry=ttu&g_ep=EgoyMDI1MDQyMy4wIKXMDSoASAFQAw%3D%3D"><p><div><FaMapMarkerAlt /></div>    3158, Vadwali Mehta Pole, Shahpur,
              Ahmedabad, Gujarat, 380001</p></a>
            {/* <div className="social-links">
              <a href="#"><FaFacebook /></a>
              <a href="#"><FaInstagram /></a>
              <a href="#"><FaLinkedin /></a>
            </div> */}
          </div>


          {/* Social Media Links */}

        </div>
      </section >

      {/* Map and Directions */}
      < section className="map-container" >
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.6289046701027!2d72.57707307499183!3d23.037393915775503!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e8534399d8e91%3A0x74e710d0ac8e1878!2sVadvali%20Mehta%20Pole!5e0!3m2!1sen!2sin!4v1743497120481!5m2!1sen!2sin" allowfullscreen="" loading="lazy" ></iframe>
      </section >
    </div >
  );
};

export default ContactPage;
